import { Injectable } from '@nestjs/common';
import { PoItems } from '../po-creation-items.entity';
import { PoCreation } from '../po-creation.entity';
import { PoItemsAdapter } from './po-creation-items.adapter';
import { PurchaseOrderDTO } from './po-creation.dto';
import { PoDetailsDTO } from './po-details-create.dto';

@Injectable()
export class PurchaseOrderAdapter {
  constructor(private itemsAdapter:PoItemsAdapter){}
  /**
   *
   * @param PurchaseOrderDto
   * @returns PurchaseOrder entity
   */
  public convertDtoToEntity(purchaseOrderDTO: PoDetailsDTO, currentFinancialYear:string, isUpdate: boolean = false ): PoCreation {
    const purchaseOrder = new PoCreation();
    
    
    // if(purchaseOrderDTO.saleOrderId){
      purchaseOrder.saleOrderId = purchaseOrderDTO.saleOrderId;
    // }
    purchaseOrder.purchaseOrderDate=purchaseOrderDTO.purchaseOrderDate;
    purchaseOrder.vendorName=purchaseOrderDTO.vendorId;    
    purchaseOrder.paymentTerms=purchaseOrderDTO.paymentTerms;
    purchaseOrder.expectedDeliveryDate=purchaseOrderDTO.expectedDeliveryDate;
    purchaseOrder.note=purchaseOrderDTO.note;
    purchaseOrder.remarks = purchaseOrderDTO.remarks;
    purchaseOrder.deliveryAddress=purchaseOrderDTO.deliveryAddress;
    purchaseOrder.billingAddress=purchaseOrderDTO.billingAddress;
    purchaseOrder.exchangeRate =purchaseOrderDTO.exchangeRate;
    purchaseOrder.totalTransportation =purchaseOrderDTO.transportation;
    purchaseOrder.poType =purchaseOrderDTO.poType;
    purchaseOrder.unitId =purchaseOrderDTO.unitId;
    if (purchaseOrderDTO.purchaseOrderId) {
      purchaseOrder.updatedUser = purchaseOrderDTO.updatedUser;
      purchaseOrder.purchaseOrderId=purchaseOrderDTO.purchaseOrderId;
    } else {
      purchaseOrder.createdUser = purchaseOrderDTO.createdUser;
      purchaseOrder.poNumber=currentFinancialYear;
    }
  
   return purchaseOrder;
  }
  public convertEntityToDto(purchaseOrderObject: PoCreation): PoDetailsDTO {
    const purchaseOrderDTO= new PoDetailsDTO;
    purchaseOrderDTO.purchaseOrderId = purchaseOrderObject.purchaseOrderId;
    purchaseOrderDTO.saleOrderId = purchaseOrderObject.saleOrderId;
    purchaseOrderDTO.purchaseOrderDate = purchaseOrderObject.purchaseOrderDate;
    purchaseOrderDTO.vendorId = purchaseOrderObject.vendorName;
    purchaseOrderDTO.poNumber = purchaseOrderObject.poNumber;
    purchaseOrderDTO.transportation = purchaseOrderObject.totalTransportation;
    purchaseOrderDTO.paymentTerms = purchaseOrderObject.paymentTerms;
    purchaseOrderDTO.expectedDeliveryDate = purchaseOrderObject.expectedDeliveryDate;
    purchaseOrderDTO.note = purchaseOrderObject.note;
    purchaseOrderDTO.remarks = purchaseOrderObject.remarks;
    purchaseOrderDTO.deliveryAddress = purchaseOrderObject.deliveryAddress;
    purchaseOrderDTO.createdUser = purchaseOrderObject.createdUser;
    purchaseOrderDTO.updatedUser = purchaseOrderObject.updatedUser;
    return purchaseOrderDTO;
  }
}
